import { Component, OnInit } from '@angular/core';
import { ComissaoService } from 'src/app/admihair/service/comissao.service';
import { AdmihairBaseComponent } from '../../../admihair-base.component';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { Paginador } from 'src/app/admihair/api/dto/paginacao/paginador';
import { ComissaoProfissional } from 'src/app/admihair/api/dto/comissao-profissional';
import { Table } from 'primeng/table';
import { LazyLoadEvent, SelectItem } from 'primeng/api';
import { Contrato } from 'src/app/admihair/api/dto/contrato';
import { Profissional } from 'src/app/admihair/api/dto/profissional';
import { ContratoService } from 'src/app/admihair/service/contrato.service';
import { ProfissionalService } from 'src/app/admihair/service/profissional.service';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-comissao-listar',
  templateUrl: './comissao-listar.component.html',
  styleUrls: ['./comissao-listar.component.scss']
})
export class ComissaoListarComponent extends AdmihairBaseComponent implements OnInit {

  loading: boolean = true;
  loadingRelatorio: boolean = false;
  pageComissoes: Paginador<ComissaoProfissional> = {
    size: 5,
    content: [],
    number: 0,
    totalElements: 0,
    totalPages: 0
  }
  numeroPagina: number = 0;
  inputBusca?: string = '';
  tamanhoPagina: number = 10;
  linhasTabela: number = 10;
  ordenacao: string = 'dataMovimento,DESC';

  filtroDataInicio: Date = new Date();
  filtroDataFim: Date = new Date();

  listaTiposComissao: SelectItem[] = [
    {label: 'TODOS', value: undefined},
    {label: 'PRODUTO', value: 3},
    {label: 'SERVIÇO', value: 4}
  ];
  tipoComissaoSelecionado?: number;

  listaEquipes: SelectItem[] = [
    {label: 'TODOS', value: undefined}
  ];
  equipeSelecionada?: Contrato;

  listaProfissionais: SelectItem[] = [
    {label: 'TODOS', value: undefined}
  ];
  profissionalSelecionado?: Profissional;


  constructor(private comissaoService: ComissaoService,
    private contratoService: ContratoService,
    private profissionalService: ProfissionalService,
    erroService: ErroService,
    storageService: UtilStorageService,
  ) { super(erroService, storageService) }

  ngOnInit(): void {
    this.permissaoListar = this.verificarPermissao('PERM_LISTAR_COMISSOES');
    if (this.permissaoListar) {
      this.carregadosIniciais();
    }
  }

  carregadosIniciais() {
    const empresaId = this.getEmpresa().id;

    forkJoin({
      equipes: this.contratoService.listarPorEmpresaId(empresaId),
      profissionais: this.profissionalService.listarPorEmpresaId(empresaId)
    }).subscribe({
      next: ({equipes, profissionais}) => {
        equipes.map(e => (this.listaEquipes.push({label: e.razaoSocial, value: e})));
        profissionais.map(p => (this.listaProfissionais.push({label: p.nomeProfissional, value: p})));
      },
      error: (err: any) => {
        this.exibirMensagemErro(err);
      }
    })
  }

  carregarDados() {
    this.comissaoService.listarPorEmpresa(
      this.getEmpresa().id,
      this.numeroPagina,
      this.tamanhoPagina,
      this.ordenacao,
      this.filtroDataInicio,
      this.filtroDataFim,
      this.tipoComissaoSelecionado,
      this.equipeSelecionada?.id,
      this.profissionalSelecionado?.id
    ).subscribe({
      next: (data: Paginador<ComissaoProfissional>) => {
        this.pageComissoes = data;
        this.loading = false;
      },
      error: (err: any) => {
        this.loading = false;
        this.exibirMensagemErro(err)
      }
    })
  }

  obterRelatorio() {
    this.loadingRelatorio = true;
    this.comissaoService.obterRelatorio(
      this.getEmpresa().id,
      this.filtroDataInicio,
      this.filtroDataFim,
      this.tipoComissaoSelecionado,
      this.equipeSelecionada?.id,
      this.profissionalSelecionado?.id
    ).subscribe({
      next: (data: any) => {
        
        const blob = new Blob([data], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);

        if(1 === 1) {
          const a = document.createElement('a');
          a.href = url;
          a.download = `relatorio_comissao_${this.profissionalSelecionado?.nomeProfissional}.pdf`;
          a.click();
          a.remove();

        } else {
          const pdfWindow = window.open(url, '_blank');
          if(pdfWindow) {
            pdfWindow.addEventListener('load', () => pdfWindow.print());
          }

        }

        window.URL.revokeObjectURL(url);
        this.loadingRelatorio = false;

      },
      error: (err: any) => {
        this.loadingRelatorio = false;
        this.exibirMensagemErro(err)
      }
    })
  }


  onLazyLoad(event: LazyLoadEvent) {
    if (event.first !== undefined && event.rows !== undefined) {
      if (event.first === 0 && event.rows === 0) {
        this.numeroPagina = 0;
      } else {
        this.numeroPagina = event.first / event.rows;
      }
    }
    this.definirOrdenacao(event.sortField, event.sortOrder);
    this.loading = true;
    this.carregarDados();
  }

  definirOrdenacao(sortField?: string, sortOrder?: number) {
    if (sortField && sortOrder) {
      const campoDeOrdenacao = sortField ? sortField : 'dataMovimento';
      const direcaoOrdenacao = sortOrder === -1 ? 'DESC' : 'ASC';
      this.ordenacao = `${campoDeOrdenacao},${direcaoOrdenacao}`;
    } else {
      this.ordenacao = 'dataMovimento,DESC';
    }
  }

  alterarFiltro(table: Table) {
    table.clear();
  }

  buscar(table: Table, event: Event) {
    this.inputBusca = (event.target as HTMLInputElement).value;
    this.numeroPagina = 0;
    table.clear();
  }

  limpar(table: Table) {
    this.inputBusca = '';
    this.profissionalSelecionado = undefined;
    this.equipeSelecionada = undefined;
    this.tipoComissaoSelecionado = undefined;
    table.reset();
  }

}
